<span
  class="__tag"
  [class.is-active]="!!activeTags?.[slug]"
  *ngIf="data && data[slug]"><mat-icon class="__tag_icon" [svgIcon]="data[slug]?.logo || undefined">{{ data[slug]?.icon }}</mat-icon>&nbsp;{{ data[slug]?.tag }}</span>
